import { makeObservable, observable } from 'mobx';
import { ApiService } from '../Services';
import { NotificationType, StatusTypeDTO } from '../Models/ApiModels';
import { ApiURL } from '../AppConstants';

export class AppStore {
    @observable public statusTypes: StatusTypeDTO[] = [];
    @observable public resetGridVisible: boolean = false;
    @observable public notifications: Map<number, NotificationType> = new Map<number, NotificationType>();

    constructor () {
        makeObservable(this);
    }

    public showGridReset () {
        this.resetGridVisible = true;
    }

    public hideGridReset () {
        this.resetGridVisible = false;
    }

    public init () {
        void this._loadStatusTypes();
    }

    public showNotification (notification: NotificationType) {
        this.notifications.set((new Date()).getTime(), notification);
    }

    public hideNotification = (key: number) => () => {
        this.notifications.delete(key);
    };

    private async _loadStatusTypes () {
        const { data } = await ApiService.getData<StatusTypeDTO[]>(`${ApiURL.StatusTypes}`);
        this.statusTypes = data;
    }

}